import React from "react";
import settingable from "fantastic/components/hoc/settingable";
import SingleNumberSetting from "fantastic/components/common/controls/SingleNumberSetting";
import ToggleSetting from "fantastic/components/common/controls/ToggleSetting";
import SlideredNumberSetting from "fantastic/components/common/controls/SlideredNumberSetting";
import BorderSettings from "fantastic/components/common/controls/border/Settings";

const SectionSettings = ({
  selected,
  update,
  selectedNode: {
    full_width,
    border_radius,
    border_color,
    border_style,
    border_width
  },
  scrollToIfNeeded
}) => {

  const onChange = (field, value) => {
    update(selected, { [field]: value });
  };

  const fullWidthParams = {
    onChange,
    label: i18n.t('background_full_width'),
    field: 'full_width',
    value: full_width
  };

  const borderParams = {
    onChange,
    scrollToIfNeeded,
    color: { field: "border_color", value: border_color },
    style: { field: "border_style", value: border_style },
    size: { field: "border_width", value: border_width, max: 6 },
    radius: { field: "border_radius", value: border_radius },
  };

  return (
    <div>
      <ToggleSetting {...fullWidthParams} />
      <SlideredNumberSetting
        min={0}
        max={100}
        step={1}
        value={border_radius}
        label={i18n.t('border_radius')}
        onChange={(value) => onChange('border_radius', value)}
      />
      <BorderSettings {...borderParams} />
    </div>
  );
};

export default settingable("background", "visibility", "padding")(SectionSettings);
